import { useEffect, useState } from 'react';

type MediaQueryDetails = {
  matches: boolean;
  media: string;
};

export const useMatchMedia = () => {
  const [mQuery, setMQuery] = useState<MediaQueryDetails>(() => ({
    matches: typeof window !== 'undefined' ? window.innerWidth > 1024 : true,
    media: '(min-width: 1024px)',
  }));

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    setMQuery({ matches: mediaQuery.matches, media: mediaQuery.media });

    const listener = ({ matches, media }: MediaQueryListEvent) => {
      setMQuery({ matches, media });
    };

    mediaQuery.addEventListener('change', listener);
    return () => mediaQuery.removeEventListener('change', listener);
  }, []);

  return mQuery;
};
